import SigningLinkDialog from './SigningLinkDialog.jsx';
import { requestSnkl } from '@/services/deals.service.js';

// "Request SNKL signature" on a Deal: the shared Tower signing-link dialog,
// pointed at /api/snkl/deal/:id/request.
export default function SnklRequestDialog(props) {
  return <SigningLinkDialog {...props} request={requestSnkl} docName="Statement of No Known Loss" shortName="SNKL" />;
}
